import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgCloudIcon(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M15.98 6.76c0-3.31-2.68-5.99-5.99-5.99-4.14 0-5.74 4.29-5.74 4.29s-.43-.01-.51-.01h-.03c-2.27 0-3.72 1.8-3.72 4.01 0 2.22 2.15 4.02 4.02 4.02h4.16c.18.64.5 1.26 1.01 1.76.78.78 1.8 1.17 2.83 1.17a3.986 3.986 0 0 0 3.24-6.32c.42-.82.73-1.8.73-2.93Zm-7.97 5.08H4c-1.25 0-2.77-1.28-2.77-2.77 0-.79.25-1.5.69-2 .44-.5 1.06-.76 1.8-.76.08 0 .48.01.48.01l.9.03.31-.84c.01-.03 1.33-3.48 4.57-3.48a4.75 4.75 0 0 1 4.74 4.74c0 .74-.17 1.41-.43 2a3.96 3.96 0 0 0-2.3-.74c-1.02 0-2.05.39-2.83 1.17a3.95 3.95 0 0 0-1.15 2.64Zm2.04-1.76c.52-.52 1.21-.81 1.94-.81.61 0 1.19.21 1.67.58-.75 1.03-1.7 1.71-2.14 1.99H9.26c.04-.64.3-1.27.79-1.76Zm3.89 3.89a2.732 2.732 0 0 1-4.47-.88h2.4s1.43-.76 2.61-2.23c.47 1.02.3 2.27-.54 3.11Z",
    fill: "currentColor"
  }));
}

export { SvgCloudIcon as default };
